export default defineNuxtRouteMiddleware(async () => {
  if (localStorage.getItem("courseList")) {
    useBelajarWajibReaderStore().$patch((state) => {
      state.courseList = JSON.parse(localStorage.getItem("courseList")) || [];
    });
  }
});
